<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
  <div fxLayout="row" fxLayoutGap="10px">
    <i class="fa fa-share-square-o" aria-hidden="true" style="font-size: 24px; color: #707070;" (click)="exportCsvFile()"></i>
    <!-- <mat-icon [fontSize]="'24px'" class="color-blue" (click)="exportCsvFile()" pointer>download</mat-icon> -->
  </div>
</div>
